import React, { Fragment, useState, useEffect, useContext, useRef } from 'react'
import MyNavBar2 from '../myComponents/MyHeader/MyNavBar2'
import MyHeaderBg from '../myComponents/MyHeaderBg/MyHeaderBg'
import Calendar from '../Icons/Calendar'
import intl from 'react-intl-universal'
import Yes from '../Icons/Yes'
import { LanguageContext } from '../../contexts/LanguageContext'
import MyComfirmMsg from '../myComponents/MyComfirmMsg/MyComfirmMsg'
import MyModal from '../myComponents/MyModal/MyModal'
import { OrderMarkContext } from '../../contexts/OrderMark'
import useRouter from '../../hooks/useRouter'

import {
  HeaderWrapper,
  DetailsWrapper,
  ListItem,
  Receipt
} from './OrderDetailsStyle.js'
import {
  getOrderStatus,
  getOrderDetail,
  handleComfirmCancelOrder,
  refundOrder,
  rePayByOrderID,
  cancelByOrderID
} from './HistoryDetailFunction'
import {
  isObjEmpty
} from '../Order/OrderFunction'

export default function OrderDetails (props) {
  const router = useRouter()
  const Language = useContext(LanguageContext)
  const OrderMark = useContext(OrderMarkContext)
  const [subscribe, setSubscribe] = useState(true) // 订餐状态true：正在订餐，false为取消订餐
  const [cancelNum, setCancelNum] = useState(0) // 选择的取消订单的个数
  const [tabDisplay, setTabDisplay] = useState(false) // 提示确认框的状态
  const [clickStatus, setClickStatus] = useState('start')
  const [orderDetailList, setOrderDetailList] = useState([]) // 订单食物列表
  const [dateArr, setDateArr] = useState([]) // 餐次的日期
  const [showModal, setShowModal] = useState(false) // 是否显示提示信息弹窗
  const [modalInfo, setModalInfo] = useState('') // 提示信息弹窗的提示文本内容
  const [info, setInfo] = useState('') // 点击确认退餐的提示框的信息
  const orderId = props.match.params.id
  const [orderStatus, setOrderStatus] = useState('')
  const [statusId, setStatusId] = useState(null)
  const payBottonRef = useRef('payBottonRef')
  const cancelBottonRef = useRef('cancelBottonRef')
  const [checkList, setCheckList] = useState([])
  const [advanceDay, setAdvanceDay] = useState(0) // 提前多少天预订的
  const [flag, setFlag] = useState('')
  useEffect(() => {
    getOrderStatus(orderId, setOrderStatus, Language, setShowModal, setModalInfo, setSubscribe)
    getOrderDetail(OrderMark, Language, setShowModal, setModalInfo, orderId, setOrderDetailList, setDateArr)
    setInfo(intl.get('Are you sure you want to return these dishes?'))
  }, [])
  useEffect(() => {
    if (flag !== '') {
      clearTimeout(statusId)
      let delay = 5000
      if (flag === 'checkRefund') {
        delay = 5000
      } else if (flag === 'checkCancel') {
        delay = 7000
      }
      const tmpstatusId = setTimeout(() => {
        // 重新读取一下orderStatus 和 paystatus
        getOrderStatus(orderId, setOrderStatus, Language, setShowModal, setModalInfo, setSubscribe)
        getOrderDetail(OrderMark, Language, setShowModal, setModalInfo, orderId, setOrderDetailList, setDateArr, flag, checkList, setCheckList)
        setFlag('')
      }, delay)
      setStatusId(tmpstatusId)
    }
    return () => {
      // 清除定时器
      clearTimeout(statusId)
    }
  }, [flag])
  // 设置需要提前多少天预订饭菜
  useEffect(() => {
    if (!isObjEmpty(OrderMark.properties)) {
      if (OrderMark.properties.effectiveDays) {
        OrderMark.properties.effectiveDays.length > 0 && setAdvanceDay(OrderMark.properties.effectiveDays[0])
      }
    }
  }, [OrderMark.properties])
  return (
    <Fragment>
      <HeaderWrapper className='ffyy rel'>
        <MyHeaderBg />
        <MyNavBar2 history={props.history} leftClick={() => router.history.push('/historicalOrders')}>
          {intl.get('Order details')}
        </MyNavBar2>
        {/* <h4 className='h7 mt12 ml20 gf fs21 fw1'>
          {orderStatus === null && intl.get('Unpaid')}
          {orderStatus === 0 && intl.get('Unpaid')}
          {orderStatus === 1 && <div>{intl.get('Effective')}<span className='dot dib ml2 mb3 lh1-0 tl ovh gf fs25'>...</span></div>}
          {orderStatus === 2 && intl.get('Finished')}
        </h4> */}
      </HeaderWrapper>
      <DetailsWrapper className='ffyy'>
        {
          dateArr.length > 0 && dateArr.map(dateItem => {
            return (
              <ListItem className='rds10 bgf mb22' key={dateItem}> {/* 订单详情的外层大盒子 */}{/* 此页面的样式引入了common.css的样式 */}
                <ul className='list-top flex bgd'>                              {/* 订单详情的上面日期部分 */}
                  <li className='w15 tr'>
                    <div className='pt3 pr10'>
                      <Calendar height={22} width={22} />                       {/** 左侧图标 */}
                    </div>
                  </li>
                  <li className='w85 g48 fs14'>{dateItem}</li>          {/* 日期 */}
                </ul>
                {
                  OrderMark.mealtypes.map(mealItem => {
                    // console.log(mealItem)
                    return (
                      <ul className='list-bottom' key={mealItem.id}>                            {/* 日期下面的大盒子 */}
                        <li className='w14 ovh'>                              {/* 左侧显示虚线的盒子 */} {/* 盒子设置overflow，保证内部虚线不溢出 */}
                          <div className={'textMsg w38r rds5 tc bd ' + (
                            orderDetailList.filter(item => item.takeFoodTime && dateItem && item.takeFoodTime.substr(0, 10) === dateItem.substr(0, 10) && item.mealTypeID === mealItem.id).length > 0 ? ' db ' : ' dn ') + (Language.locale && Language.locale.includes('en') ? ' fs12 ' : ' ') +
                            (mealItem.mealName && mealItem.mealName.length < 7 ? ' pt2 pb2 ' : '')
                          }
                          >
                            <div style={Language.locale && Language.locale.includes('en') ? { transform: 'scale(0.9)' } : {}}>
                              {mealItem.mealName}
                            </div>
                          </div>
                          <div className='h100'>
                            <div className='dash h100 w0 auto' />
                          </div>
                        </li>
                        <li className={'w72 ' + (
                          orderDetailList.filter(item => item.takeFoodTime && dateItem && item.takeFoodTime.substr(0, 10) === dateItem.substr(0, 10) && item.mealTypeID === mealItem.id).length > 0 ? ' db ' : ' dn ')}>                                  {/* 虚线右侧的大盒子 */}
                          <div className='pt5 pl5'>
                            {
                              orderDetailList.length > 0 && orderDetailList.map(listitem => {
                                // console.log(listitem)
                                if (clickStatus === 'cancel' || clickStatus === 'close') {
                                  listitem.tmpOrder = listitem.order
                                }
                                if (clickStatus === 'ok') {
                                  listitem.order = listitem.tmpOrder
                                }
                                if (listitem.takeFoodTime && dateItem && listitem.takeFoodTime.substr(0, 10) === dateItem.substr(0, 10) && listitem.mealTypeID === mealItem.id) {
                                  return (
                                    <div key={dateItem.replace(/[-]/g, '') + mealItem.id + listitem.id} className='flex rel'>
                                      <div className={subscribe ? 'foodList rds10 bgf mb5' : 'foodList cancel rds10 bgf mb5'}>  {/* 右侧内部的食物小条目 */}
                                        <ul className='foodItem h100 flex rds10 rel'>
                                          <li className='w20 h100 flex'>
                                            {
                                              listitem.picAddress && listitem.picAddress.indexOf('sodexo') >= 0
                                                ? <img className='db rds10 ml4' alt={intl.get('No pictures')} src={listitem.picAddress} />
                                                : <div className='ml4 h70 bgf1 vc rds10 '>
                                                  <div className={'tc w100 fs10 ga5' + (Language.locale === 'en' ? '' : ' lt1-5')}>{intl.get('No pictures')}</div>
                                                </div>
                                            }
                                          </li>
                                          <li className={'lh1-3 fs13 g4f pl10' + (subscribe ? ' w60' : ' w50')} style={{ display: 'flex'}}>
                                            <div className='no-wrap' style={{ width: '85%'}}>
                                              <span style={{ width: '85%'}}>{listitem.foodName}</span>
                                            </div>
                                            <div style={{ width: '15%'}}><span>×</span>{listitem.count}</div>
                                            {
                                              !isObjEmpty(OrderMark.properties) && ((OrderMark.properties.isFoodGang && OrderMark.properties.isCombinationFoodWriteHis && listitem.isPotFood === 1) || (listitem.isPotFood === 0 && OrderMark.properties.isPotFoodWriteHis)) &&
                                                <div className='tips rds5 bd fs12 h15r tc dib pl3 pr3' style={{ lineHeight: '1.07rem' }}>
                                                  {intl.get('Pay upon discharge')}
                                                </div>
                                            }
                                          </li>
                                          <li className={subscribe ? ' w20' : ' w30'} />
                                          <li className='price abs g4f fs14'>
                                            <b>&yen;{ (Math.round(parseFloat(listitem.foodUnitPrice * listitem.count * 100)) / 100)===0?' --':' '+ (Math.round(parseFloat(listitem.foodUnitPrice * listitem.count * 100)) / 100) }</b>
                                          </li>
                                          {
                                            // 待付款
                                            listitem.tmpPayStatus === 0 &&
                                            <div className='abs h18r pl3 pr3 infoOrder gf15b6c fs12 bd rds5 tc'>
                                              {intl.get('Unpaid')}
                                            </div>
                                          }
                                          {
                                            // 已付款（已下单）
                                            listitem.tmpPayStatus === 1 &&
                                            <div className='abs h18r pl3 pr3 infoOrder gf15b6c fs12 bd rds5 tc'>
                                              {intl.get('Booked')}
                                            </div>
                                          }
                                          {
                                            // 已取消
                                            listitem.tmpPayStatus === 2 &&
                                            <div className='abs h18r pl3 pr3 infoOrder gf15b6c fs12 bd rds5 tc'>
                                              {intl.get('Cancelled')}
                                            </div>
                                          }
                                          {
                                            // 退餐中
                                            listitem.tmpPayStatus === 3 &&
                                            <div className='abs h18r pl3 pr3 infoOrder g717ffa fs12 bd rds5 tc'>
                                              {intl.get('Refunding')}
                                            </div>
                                          }
                                          {
                                            // 已退餐
                                            listitem.tmpPayStatus === 4 &&
                                            <div className='abs h18r pl3 pr3 infoOrder g717ffa fs12 bd rds5 tc'>
                                              {intl.get('Refunded')}
                                            </div>
                                          }
                                          {
                                            // 已完成
                                            listitem.tmpPayStatus === 5 &&
                                            <div className='abs h18r pl3 pr3 infoOrder g00d89e fs12 bd rds5 tc'>
                                              {intl.get('Finished')}
                                            </div>
                                          }
                                        </ul>
                                      </div>
                                      {/* <div className={subscribe ? 'clickDot abs' : 'clickDot abs cancel'}>
                                        <input
                                          id={listitem.uniqueID}
                                          className='checkBox abs'
                                          type='checkbox'
                                          checked={!listitem.tmpOrder}
                                          onChange={(e) => {
                                            listitem.tmpOrder = !e.target.checked
                                            console.log(orderDetailList)
                                            e.target.checked ? setCancelNum(cancelNum + 1) : setCancelNum(cancelNum - 1)
                                          }
                                          } />
                                        {// payStatus为1代表支付已成功
                                          listitem.tmpPayStatus === 1
                                            ? <label className='labelBox bdc bgf db w17px h17px rds50 auto' htmlFor={listitem.uniqueID}>
                                              <div className='yesBox dn pl1'>
                                                <Yes height={16} width={16} />
                                              </div>
                                            </label>
                                            : ''
                                        }
                                      </div> */}
                                    </div>
                                  )
                                }
                              })
                            }
                          </div>                         
                        </li>
                        <li className={subscribe? 'w0' : 'w14'}>
                          <div className={'textMsg w38r rds5 tc ' + (
                            orderDetailList.filter(item => item.takeFoodTime && dateItem && item.takeFoodTime.substr(0, 10) === dateItem.substr(0, 10) && item.mealTypeID === mealItem.id).length > 0 ? ' db ' : ' dn ') + (Language.locale && Language.locale.includes('en') ? ' fs12 ' : ' ') +
                            (mealItem.mealName && mealItem.mealName.length < 7 ? ' pt2 pb2 ' : '')
                          }
                          >
                            <div className='h100'>
                              <input 
                                className='checkBox abs'
                                id={mealItem.id}
                                checked={orderDetailList.filter(item => item.takeFoodTime && dateItem && item.takeFoodTime.substr(0, 10) === dateItem.substr(0, 10) && item.mealTypeID === mealItem.id && item.tmpOrder).length > 0 ? false : true}
                                onChange={(e) => {
                                  // listitem.tmpOrder = !e.target.checked
                                  console.log(orderDetailList)
                                  console.log(e.target.checked)
                                  orderDetailList.map((fo) => {
                                    if(fo.takeFoodTime && dateItem && fo.takeFoodTime.substr(0, 10) === dateItem.substr(0, 10) && fo.mealTypeID === mealItem.id){
                                      fo.tmpOrder = !e.target.checked
                                    }
                                  })
                                  console.log(orderDetailList)
                                  var num = orderDetailList.filter(item => item.takeFoodTime && dateItem && item.takeFoodTime.substr(0, 10) === dateItem.substr(0, 10) && item.mealTypeID === mealItem.id).length
                                  e.target.checked ? setCancelNum(cancelNum + num) : setCancelNum(cancelNum - num)
                                }}
                                type='checkbox'>
                                </input>
                                <label style={{ display:'block'}} class="labelBox bdc bgf w17px h17px rds50 auto" htmlFor={mealItem.id}>
                                  <div className='yesBox dn pl1'>
                                    <Yes height={16} width={16} />
                                  </div>
                                </label>
                            </div>
                          </div>
                        </li>
                      </ul>
                    )
                  })
                }
              </ListItem>
            )
          })
        }
      </DetailsWrapper>
      <div style={{ height: '150px' }} />       {/* 此标签用于占位，让底部订单能看得见。应该大于发票高度(140px) */}
      <Receipt className='fixed w100 bgf rds5 ffyy'> {/* 最下方的发票信息 */}
        <div className='h8'>                    {/* 分割线 */}
          <div className='w80 auto' />
        </div>
        <div className='orderMsg h18 fs15'>{intl.get('Order information')}</div>
        <ul className='h23 flex g6 fs14'>
          <li className='w50 tl'>
            <div className='g8a8a8a pl28'>{intl.get('Name of patient:')}</div>
          </li>
          <li className='w50 tr'>
            <div className='patientNameBox'>{OrderMark.patientName}</div>
          </li>
        </ul>
        <ul className='h23 flex fs14'>
          <li className='w50 tl'>
            <div className='bedBox pl28'>{intl.get('Bed information:')}</div>
          </li>
          <li className='w50 tr'>
            <div className='bednumBox'>{OrderMark.position}</div>
          </li>
        </ul>
        {
          (orderStatus === 0) &&
            <ul className='h28 pt4 flex mr30 tr'>
              <li className='w60' />
              <li className='w20 h100'>
                <button id='payBtnid' className='abs clip' ref={payBottonRef}
                  onClick={() => {
                    rePayByOrderID(payBottonRef, orderId, Language, setShowModal, setModalInfo, props.history)
                  }}
                />
                <label htmlFor='payBtnid' className='h25r dib pl10 pr10 bg72 wMin80 fs14 gf rds12 tc bg00d89e' style={{ lineHeight: '1.78rem' }}>
                  {intl.get('Pay')}
                </label>
              </li>
              <li className='w20 h100'>
                <button id='cancelBtnid' className='abs clip' ref={cancelBottonRef}
                  onClick={() => {
                    cancelByOrderID(cancelBottonRef, orderId, Language, setShowModal, setModalInfo, setFlag)
                  }}
                />
                <label htmlFor='cancelBtnid' className='unsubscribe h25r dib lh1-8 pl10 pr10 wMin80 fs14 bd rds12 tc'>
                  {intl.get('Cancel')}
                </label>
              </li>
            </ul>
        }
        {
          (orderStatus === 1 && subscribe) &&
            <div className='h28 pt4'>
              <div
                className='unsubscribe bd abs h25r lh1-8 pl10 pr10 r30 wMin17 fs14 rds12 tc lauto'
                onClick={() => {
                  setCancelNum(0)
                  setSubscribe(false)
                  setClickStatus('start')
                }}>
                {intl.get('Unsubscribe')}
              </div>
            </div>
        }
        {
          (orderStatus === 1 && !subscribe) &&
            <ul className='h28 flex mr30'>
              <li className='w8 tl'>
                <div className='w11px h11px bga rds50 auto' />
              </li>
              <li className='w44 tl'>
                <div className='bedBox fs13'>{intl.get('Selected')} <b>{cancelNum}</b> {intl.get('dishes')}</div>
              </li>
              <li className='w26 tr rel'>
                <button id='btn' className='abs clip'
                  onClick={() => {
                    handleComfirmCancelOrder(orderDetailList, OrderMark, orderStatus, cancelNum, setShowModal, setModalInfo, setTabDisplay, advanceDay)
                  }}
                />
                <label htmlFor='btn'className='h25r w90 gf3014d lh1-8 db rds12 tc fs14 tc bd'>
                  {intl.get('Sure')}
                </label>
              </li>
              <li
                className='w22'
                onClick={() => {
                  setSubscribe(true)
                  setClickStatus('cancel')
                }}
              >
                <div className='h25r g00d89e gf tc lh1-8 fs14 rds12 bd'>
                  {intl.get('Cancel')}
                </div>
              </li>
            </ul>
        }
      </Receipt>
      <MyComfirmMsg
        visible={tabDisplay}
        info={info}
        onOkClick={() => {
          setSubscribe(true)
          setCancelNum(0)
          setClickStatus('ok')
          setTabDisplay(false)
          refundOrder(orderDetailList, setOrderDetailList, orderId, Language, setShowModal, setModalInfo, checkList, setCheckList, setFlag)
        }}
        onCloseClick={() => {
          setSubscribe(true)
          setCancelNum(0)
          setClickStatus('close')
          setTabDisplay(false)
        }}
        onCancelClick={() => {
          setSubscribe(true)
          setCancelNum(0)
          setClickStatus('cancel')
          setTabDisplay(false)
        }}
      />
      <MyModal
        visible={showModal}
        info={modalInfo}
        cancelButtonVisible={false}
        onOkClick={() => setShowModal(false)}
      />
    </Fragment>
  )
}
